module.exports = __webpack_public_path__ + "img/a189081c3d88d00af3685ccd453d1945.png";